import request from '@/utils/request'

export const findPostsPage = (pageCode, pageSize, categoryId) => {
    return request({
        url: '/admin/posts/page',
        method: 'get',
        params: {
            pageCode,
            pageSize,
            categoryId
        }
    })
}

export const addPosts = (posts) => {
    return request({
        url: '/admin/posts',
        method: 'post',
        data: posts,
    })
}

export const updatePosts = (posts) => {
    return request({
        url: '/admin/posts',
        method: 'put',
        data: posts,
    })
}

export const deletePosts = (id) => {
    return request({
        url: `/admin/posts/${id}`,
        method: 'delete',
    })
}

export const findPostsSearch = (title) => {
    return request({
        url: `/admin/posts/search`,
        method: 'get',
        params: {
            title
        }
    })
}

export const updateSortTop = (postsId, categoryId, sort) => {
    return request({
        url: '/admin/posts/sort/top',
        method: 'put',
        params: {
            postsId,
            categoryId,
            sort
        }
    })
}

export const updateSortBottom = (postsId, categoryId, sort) => {
    return request({
        url: '/admin/posts/sort/bottom',
        method: 'put',
        params: {
            postsId,
            categoryId,
            sort
        }
    })
}


export const uploadConfig = () => {
    return request({
        url: '/upload/config',
        method: 'get',
    })
}

export const upload = () => {
    return request({
        url: '/upload',
        method: 'post',
    })
}


export const findCategoryTree = () => {
    return request({
        url: '/admin/category/tree',
        method: 'get',
    })
}

export const findCategoryAll = () => {
    return request({
        url: '/admin/category',
        method: 'get',
    })
}

export const login = (username, password) => {
    return request({
        url: '/admin/user/login',
        method: 'post',
        params: {
            username,
            password
        }
    })
}

export const logout = () => {
    return request({
        url: '/admin/user/logout',
        method: 'delete',
    })
}

export const findUserPage = (pageCode, pageSize) => {
    return request({
        url: '/admin/user/page',
        method: 'get',
        params: {
            pageCode,
            pageSize
        }
    })
}

export const addUser = (user) => {
    return request({
        url: '/admin/user',
        method: 'post',
        data: user
    })
}

export const updatePassword = (username, password) => {
    return request({
        url: '/admin/user/pass',
        method: 'put',
        params: {
            username,
            password
        }
    })
}

export const deleteUser = (id) => {
    return request({
        url: `/admin/user/${id}`,
        method: 'delete',
    })
}

export const updateUser = (user) => {
    return request({
        url: '/admin/user',
        method: 'put',
        data: user,
    })
}

export const updateSite = (site) => {
    return request({
        url: '/admin/site',
        method: 'put',
        data: site
    })
}

//#################### 轮播图相关API ####################

export const findSlidePage = (pageCode, pageSize) => {
    return request({
        url: '/admin/slide',
        method: 'get',
        params: {
            pageCode,
            pageSize
        }
    })
}

export const addSlide = (slide) => {
    return request({
        url: '/admin/slide',
        method: 'post',
        data: slide
    })
}

export const deleteSlide = (id) => {
    return request({
        url: `/admin/slide/${id}`,
        method: 'delete',
    })
}

//#################### 友情链接API ####################

export const findLinksPage = (pageCode, pageSize) => {
    return request({
        url: '/admin/links',
        method: 'get',
        params: {
            pageCode,
            pageSize
        }
    })
}

export const addLinks = (links) => {
    return request({
        url: '/admin/links',
        method: 'post',
        data: links
    })
}

export const deleteLinks = (id) => {
    return request({
        url: `/admin/links/${id}`,
        method: 'delete',
    })
}




// WEBPACK FOOTER //
// ./src/api/back.js